import { LandPlot, FileText, ListFilter, Stamp, TreePine } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface FundiarioPipe {
  id: string;
  label: string;
  description: string;
  icon: LucideIcon;
  /** Pipe especial que abre um mapa em vez do kanban. */
  kind?: 'parent' | 'child' | 'mapa';
}

/** Pipe especial: mapa do Parque Nacional Povos Indígenas do Rio Tanaru. */
export const TANARU_PIPE_ID = 'fundiario_tanaru';

export const FUNDIARIO_PIPES: FundiarioPipe[] = [
  {
    id: 'triagem_geo',
    label: 'Triagem Fundiário',
    description: 'Qualificação da demanda antes da execução.',
    icon: ListFilter,
    kind: 'parent',
  },
  {
    id: 'geo',
    label: 'GEO',
    description: 'Pipeline GEO até certificação SIGEF.',
    icon: LandPlot,
    kind: 'child',
  },
  {
    id: 'ccir',
    label: 'CCIR',
    description: 'Cadastro de imóveis rurais.',
    icon: FileText,
  },
  {
    id: 'titulacao',
    label: 'Titulação',
    description: 'Processos INCRA de titulação.',
    icon: Stamp,
  },
  {
    id: TANARU_PIPE_ID,
    label: 'Tanaru',
    description: 'Parque Nacional Povos Indígenas do Rio Tanaru — Decreto 13.016/2026.',
    icon: TreePine,
    kind: 'mapa',
  },
];
